<template>
    <section>
        <v-container class="nav">
            <v-btn
                icon
                class="black--text"
                @click="$router.go(-1)"
            >
                <v-icon>{{ mdiArrowLeft }}</v-icon>
            </v-btn>
            <v-card-title>
                <v-row align="center">
                    <v-col
                        cols="2"
                        sm="2"
                        lg="1"
                        class="pr-0"
                        align="right"
                    >
                        <v-avatar class="page-icon teal mr-2 elevation-5">
                            <v-icon large class="white--text">
                                {{ mdiTable }}
                            </v-icon>
                        </v-avatar>
                    </v-col>
                    <v-col
                        cols="10"
                        sm="10"
                        lg="11"
                        class="pl-0"
                    >
                        <h2 style="word-break: normal;">
                            OPPAN History
                        </h2>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-divider />
            <div v-if="getHistory.length > 0">
                <v-data-table
                    :headers="headers"
                    :items="getData"
                    :footer-props="footer_props"
                    class="my-10 elevation-10"
                    :hide-headers="true"
                >
                    <template #item="{ item }">
                        <tr v-if="screen_width < 600">
                            <td colspan="4">
                                <ul class="flex-content">
                                    <div class="content d-flex justify-space-between" style="width:100%" @click="showDialog(item.OPAN_N)">
                                        <label>Appr.#.:</label>
                                        <li class="flex-item" data-label="Calories">
                                            {{ item.OPAN_N }}
                                        </li>
                                    </div>
                                    <div class="content d-flex justify-space-between" style="width:100%" @click="showDialog(item.OPAN_N)">
                                        <label>Issued:</label>
                                        <li class="flex-item" data-label="Calories">
                                            {{ item.APPR_D }}
                                        </li>
                                    </div>
                                    <div class="content d-flex justify-space-between" style="width:100%" @click="showDialog(item.OPAN_N)">
                                        <label>Expiry:</label>
                                        <li class="flex-item" data-label="Calories">
                                            {{ item.VALI_D }}
                                        </li>
                                    </div>
                                    <div class="content d-flex justify-space-between" style="width:100%">
                                        <label>Action:</label>
                                        <li class="flex-item" data-label="Calories">
                                            <div v-if="item.DOWNLOADABLE && moment(item.VALID_UNTIL).format('YYYY-MM-DD') >= moment().format('YYYY-MM-DD') && (downloadable_oppans.includes(String(item.OPAN_N)[0]))">
                                                <v-btn class="teal white--text" @click="download(item.OPAN_N)">
                                                    Download
                                                </v-btn>
                                            </div>
                                            <div v-else>
                                                <i>Not available for download</i>
                                            </div>
                                        </li>
                                    </div>
                                </ul>
                            </td>
                        </tr>
                        <tr v-else>
                            <td @click="showDialog(item.OPAN_N)" v-text="item.OPAN_N"></td>
                            <td @click="showDialog(item.OPAN_N)" v-text="item.APPR_D"></td>
                            <td @click="showDialog(item.OPAN_N)" v-text="item.VALI_D"></td>
                            <td>
                                <div v-if="item.DOWNLOADABLE && moment(item.VALID_UNTIL).utcOffset('+0800').format('YYYY-MM-DD') >= moment().utcOffset('+0800').format('YYYY-MM-DD') && (downloadable_oppans.includes(String(item.OPAN_N)[0]))">
                                    <v-btn class="teal white--text" @click="download(item.OPAN_N)">
                                        Download
                                    </v-btn>
                                </div>
                                <div v-else>
                                    <i>Not available for download</i>
                                </div>
                            </td>
                        </tr>
                    </template>
                    <!--
          <template slot="item" slot-scope="props">
            <tr>
                <td @click="showDialog(props.item.OPAN_N)" v-text="props.item.OPAN_N" />
                <td @click="showDialog(props.item.OPAN_N)" v-text="props.item.APPR_D" />
                <td @click="showDialog(props.item.OPAN_N)" v-text="props.item.VALI_D" />
              <td>
                <div v-if="moment(props.item.VALID_UNTIL).format('YYYY-MM-DD') >= moment().format('YYYY-MM-DD')">
                  <v-btn class="teal white--text" @click="download(props.item.OPAN_N)">
                    Download
                  </v-btn>
                </div>
                <div v-else>
                  <i>Not available for download</i>
                </div>
              </td>
            </tr>
          </template>
          -->
                </v-data-table>
            </div>
            <div v-else>
                <p>
                    <i>
                        No information available as of this moment.
                    </i>
                </p>
            </div>
        </v-container>
        <DialogBox
            :history-data="getHistoryView"
            :show="show"
            @showDialog="showProp"
        />
    </section>
</template>

  <script>
import { moment } from '../../../utils/date-shim'
import { mapActions, mapGetters } from 'vuex'
import { saveAs } from 'file-saver'
import ClientPortal from '../../../plugins/axios'
import DialogBox from './HistoryDialog.vue'
import { mdiArrowLeft, mdiTable } from '@mdi/js'
import { base64ToBlob } from '../../../utils/helpers'
export default {
    components: {
        DialogBox
    },
    data: () => {
        return ({
            mdiArrowLeft, mdiTable,
            screen_width: document.documentElement.clientWidth + 9,
            showHistory: null,
            show: false,
            footer_props: {
                'items-per-page-options': []
            },
            downloadable_oppans: ['K', 'P', 'C', 'B'],
            headers: [
                {
                    text: 'Approval No.',
                    align: 'left',
                    value: 'OPAN_N',
                    class: 'teal--text'
                },
                {
                    text: 'Approval Date',
                    align: 'left',
                    value: 'APPR_D',
                    class: 'teal--text'
                },
                {
                    text: 'Valid Until',
                    align: 'left',
                    value: 'VALI_D',
                    class: 'teal--text'
                },
                {
                    text: 'Action',
                    align: 'left',
                    class: 'teal--text'
                }
            ]
        })
    },
    computed: {
        ...mapGetters(['getHistory', 'getHistoryView']),
        getData: {
            get() {
                let row = this.getHistory
                let data = []
                if(row) {
                    for (var i = 0; i < row.length; i++) {
                        data.push({
                            OPAN_N: row[i].OPAN_N,
                            APPR_D: moment(row[i].APPR_D).utcOffset('+0800').format('DD MMM YYYY'),
                            VALI_D: moment(row[i].VALI_D).utcOffset('+0800').format('DD MMM YYYY'),
                            VALID_UNTIL: row[i].VALI_D,
                            DOWNLOADABLE: row[i].DOWNLOADABLE ? row[i].DOWNLOADABLE : false
                        })
                    }
                }
                return data
            }
        }
    },
    async mounted() {
        window.addEventListener('resize', this.onResize)
        this.fetchHistory({ MEMBN: this.$cookies.get('usermembn') })
    },
    destroyed(){
        window.removeEventListener('resize', this.onResize)
    },
    methods: {
        ...mapActions(['fetchHistory', 'getCsrfToken', 'fetchSlip', 'viewHistory']),
        async showDialog(opan) {
            this.showHistory = opan
            await this.viewHistory({
                MEMBN: this.$cookies.get('usermembn'),
                OPPAN: opan
            })
            this.showProp(true)
        },
        showProp(show) {
            this.show = show
        },
        dataURItoBlob(dataURI) {
            const blob = base64ToBlob(dataURI, 'application/pdf')
            return blob
        },
        async download(filename) {
            await ClientPortal.post(
                `${process.env.VUE_APP_API}/login/consultation/download`,
                {
                    OPPAN_PDF_NAME: filename,
                    MEMBN: this.$cookies.get('usermembn')
                },
                {
                    withCredentials: true
                }
            ).then((response) => {
                if(response.status == 200) {
                    const file = response.data
                    const blob = this.dataURItoBlob(file.file)
                    const url = URL.createObjectURL(blob)
                    saveAs(blob, `${filename}.pdf`)
                    URL.revokeObjectURL(url)
                } else {
                    // console.log("Download Forbidden!");
                }
            })
        },
        onResize() {
            this.screen_width = document.documentElement.clientWidth
            this.screen_width = this.screen_width + 9
        }
    }
}
  </script>

  <style scoped>
  section {
    background-image: url("../../../assets/dashboardBG.webp");
    background-position: center;
    background-size: cover;
  }

  .flex-content {
    padding: 0;
    margin: 10px auto;
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    width: 100%;
}

.flex-item {
    padding: 5px;
    width: 100%;
    height: 40px;
    text-align: right;
}

@media (max-width: 390px) {
  .page-icon {
    display: none;
  }

  .v-data-table-header {
    display: none;
  }
}
@media (max-width: 599px) {
  /* Navbar */
  .nav {
    margin-top: 60px;
  }
  .nav h2 {
    font-size: 25px;
  }
  .v-data-table-header {
    display: none;
  }
}
@media (min-width: 599px) and (max-width: 968px) {
  /* Navbar */
  .nav {
    margin-top: 60px;
  }
  .nav h2 {
    font-size: 25px;
  }
  .v-data-table-header {
    display: none;
  }
}
@media (min-width: 968px) and (max-width: 1264px) {
  /* Navbar */
  .nav {
    margin-top: 60px;
  }
  .nav h2 {
    font-size: 25px;
  }
}
table tr td {
  cursor: pointer;
}
</style>
